// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.virtual_modal_body_outer__footer{height:60px}`, "",{"version":3,"sources":["webpack://./src/components/virtual_man/virtual_man.scss"],"names":[],"mappings":"AACE,kCACE,WAAA","sourcesContent":[".virtual_modal_body_outer {\n  &__footer {\n    height: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
